const initialState = {
    employeePermissions: {},
    employeeLists: [],
    singleEmployeeData: null,
    employeeCount: 0,
    changedEmployeeStatus: [],
    userStatusActivityLogs: [],
    loadingUserStatusActivityLogs: false,
    errorsUserStatusActivityLogs: {},
    loadingEmployee: false,
    errorsEmployee: {},
};

const employeeReducer = (state = initialState, action) => {
    switch (action.type) {
        case "GET_USER_STATUS_ACTIVITY_LOGS_PENDING":
            return {
                ...state,
                loadingUserStatusActivityLogs: true,
                errorsUserStatusActivityLogs: {},
            };


        case "GET_EMPLOYEELIST_PENDING":
        case "GET_EMPLOYEELISTBYID_PENDING":
        case "UPDATE_EMPLOYEE_PENDING":
        case "UPDATE_EMPLOYEE_STATUS_PENDING":
        case "DELETE_EMPLOYEE_PENDING":
            return { ...state, loadingEmployee: true, errorsEmployee: {} };

        case "GET_EMPLOYEELIST_FULFILLED":
            return {
                ...state,
                loadingEmployee: false,
                employeeLists: action.payload,
                employeeCount: action.count,
                employeePermissions: action.permissions,
            };

            

        case "GET_USER_STATUS_ACTIVITY_LOGS_FULFILLED":
            return {
                ...state,
                loadingUserStatusActivityLogs: false,
                userStatusActivityLogs: Array.isArray(action.payload) ? action.payload : [],
                errorsUserStatusActivityLogs: {},
            };

        case "GET_EMPLOYEELISTBYID_FULFILLED":
            return {
                ...state,
                loadingEmployee: false,
                singleEmployeeData: action.payload,
            };

        case "UPDATE_EMPLOYEE_FULFILLED":
            return {
                ...state,
                loadingEmployee: false,
                changedEmployeeStatus: action.payload,
                employeeLists: action.payload?.data,
                errorsEmployee: {},
            };

        case "UPDATE_EMPLOYEE_STATUS_FULFILLED":
            return {
                ...state,
                loadingEmployee: false,
                changedEmployeeStatus: action.payload,
                employeeLists: action.payload?.data,
            };

        case "DELETE_EMPLOYEE_FULFILLED":
            return {
                ...state,
                loadingEmployee: false,
                changedEmployeeStatus: action.payload,
            };

        case "RESET_DELETE_EMPLOYEE_STATUS":
            return {
                ...state,
                loadingEmployee: false,
                changedEmployeeStatus: [],
                errorsEmployee: {},
            };

        case "GET_EMPLOYEELIST_REJECTED":
        case "GET_EMPLOYEELISTBYID_REJECTED":
        case "UPDATE_EMPLOYEE_REJECTED":
        case "UPDATE_EMPLOYEE_STATUS_REJECTED":
        case "DELETE_EMPLOYEE_REJECTED":
            return {
                ...state,
                loadingEmployee: false,
                errorsEmployee: action.payload,
            };

            
        case "GET_USER_STATUS_ACTIVITY_LOGS_REJECTED":
            return {
                ...state,
                loadingUserStatusActivityLogs: false,
                userStatusActivityLogs: [],
                errorsUserStatusActivityLogs: action.payload,
            };

        case "RESET_EMPLOYEE_STATE":
            return { ...initialState };

        default:
            return state;
    }
};

export default employeeReducer;

